__webpack_require__.p = "/ghgcenter/custom-interfaces/interfaces-template/pr-preview-35/";